import styled, { css } from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';

export const FrameWrapper = styled.div`
  min-width: 288px;
  font-size: 14px;
  text-align: center;
  font-family: ${FONTS.ROBOTO_REGULAR};
  a {
    text-decoration: underline;
    color: ${COLORS.AQUA_BLUE};
  }
`;

const style = css`
  display: block;
  width: 100%;
  line-height: 24px;
  color: ${COLORS.BLACK};
`;

export const Title = styled.div`
  ${style}
  font-weight: bold;
`;

export const Text = styled.div`
  ${style}
  margin-bottom: 15px;

  &:last-child {
    margin: 0;
  }
`;